import { render, staticRenderFns } from "./DepartmentTreeSelect.vue?vue&type=template&id=025a2278&scoped=true"
import script from "./DepartmentTreeSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./DepartmentTreeSelect.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DepartmentTreeSelect.vue?vue&type=style&index=0&id=025a2278&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025a2278",
  null
  
)

export default component.exports